var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditOtp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 462"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M7.26201 2.47597H4.33974C3.17072 2.47597 2.58621 2.47597 2.13971 2.70348C1.74695 2.9036 1.42763 3.22292 1.22751 3.61568C1 4.06218 1 4.64669 1 5.81571V11.6603C1 12.8293 1 13.4138 1.22751 13.8603C1.42763 14.2531 1.74695 14.5724 2.13971 14.7725C2.58621 15 3.17072 15 4.33974 15H10.1843C11.3533 15 11.9378 15 12.3843 14.7725C12.7771 14.5724 13.0964 14.2531 13.2965 13.8603C13.524 13.4138 13.524 12.8293 13.524 11.6603V8.73799M5.17466 10.8253H6.33977C6.68013 10.8253 6.85031 10.8253 7.01047 10.7869C7.15245 10.7528 7.28819 10.6966 7.4127 10.6203C7.55313 10.5342 7.67347 10.4139 7.91414 10.1732L14.5677 3.51964C15.1441 2.94324 15.1441 2.0087 14.5677 1.4323C13.9913 0.8559 13.0568 0.855899 12.4804 1.4323L5.82678 8.08586C5.58611 8.32653 5.46577 8.44687 5.37972 8.5873C5.30342 8.71181 5.2472 8.84755 5.21311 8.98954C5.17466 9.14969 5.17466 9.31987 5.17466 9.66023V10.8253Z",
    stroke: "#2E72BD",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditOtp);
export default __webpack_public_path__ + "static/media/edit-otp.88532cc81598f708a5d068c639740100.svg";
export { ForwardRef as ReactComponent };